import { CircleIconProps } from './types';

export default function CircleMinusIcon({ className, variant = 'solid' }: CircleIconProps) {
  return (
    <svg
      width='32'
      height='32'
      viewBox='0 0 32 32'
      className={className}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      aria-hidden='true'
      focusable='false'
    >
      <rect
        x='1'
        y='1'
        width='30'
        height='30'
        rx='15'
        fill={variant === 'solid' ? 'currentColor' : variant === 'soft' ? 'currentColor' : 'white'}
        fillOpacity={variant === 'soft' ? 0.1 : undefined}
        stroke={variant === 'outline' ? 'currentColor' : 'none'}
        strokeWidth='2'
      />
      <path
        d='M10 16H22'
        stroke={variant === 'solid' ? 'white' : 'currentColor'}
        strokeWidth='1.8'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
